import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { MonthlyDataPoint } from '../../../../services/user-analytics/user-analytics.model';

@Component({
    selector: 'app-user-new-users-trend',
    templateUrl: './user-new-users-trend.component.html',
    styleUrls: ['./user-new-users-trend.component.scss'],
})
export class UserNewUsersTrendComponent implements OnChanges {
    @Input() data: MonthlyDataPoint[] = [];

    chartData: ChartConfiguration<'line'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'line'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
            x: { grid: { display: false } },
            y: { beginAtZero: true, ticks: { precision: 0 } },
        },
        elements: {
            point: { radius: 3, hoverRadius: 5 },
            line: { tension: 0.3 },
        },
    };

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;
        this.chartData = {
            labels: this.data.map((p) => this.formatMonth(p.month)),
            datasets: [
                {
                    data: this.data.map((p) => p.count),
                    borderColor: '#3a7bd5',
                    backgroundColor: '#3a7bd520',
                    pointBackgroundColor: '#3a7bd5',
                    pointBorderColor: '#3a7bd5',
                    fill: true,
                },
            ],
        };
    }

    private formatMonth(month: string): string {
        const [year, m] = month.split('-');
        const date = new Date(+year, +m - 1);
        return date.toLocaleDateString(undefined, { month: 'short', year: '2-digit' });
    }
}
